import IProject from "common/interfaces/IProject";
import Popup from "components/Popup";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import themeProps from "theme/themes";

interface MembersPopupProps {
  project?: IProject;
  handleClose: Dispatch<SetStateAction<boolean>>;
}

const MembersWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 24px 20px;
`;

const Member = styled.div`
  color: ${(props: themeProps) => props.theme.text.primary};
  padding: 8px 20px;
  width: fit-content;
  border: 1px solid ${(props: themeProps) => props.theme.border.secondary};
  border-radius: 8px;
  display: flex;
  align-items: center;
`;

const MemberPicture = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: gray;
  margin-right: 8px;
`;

const MembersPopup = ({ project, handleClose }: MembersPopupProps) => {
  const { t } = useTranslation("project");

  return (
    <Popup heading={t("members")} handleClose={handleClose}>
      <MembersWrapper>
        {project?.roles
          ?.filter((role) => role.userId)
          .map((role) => (
            <Member key={role._id}>
              <MemberPicture />
              {role.userId.name}
            </Member>
          ))}
      </MembersWrapper>
    </Popup>
  );
};

export default MembersPopup;
